import { styled } from "@mui/material";
import { ItemsContainer } from "@pageContent/common/InfiniteCollection/InfiniteCollection";
import { colors, fonts } from "@constants/cssVariables";

export const Items = styled(ItemsContainer)(({ theme }) => ({
  marginBottom: theme.spacing(10),
  [theme.breakpoints.up("md")]: {
    h5: {
      gridColumn: "1 / -1",
      margin: theme.spacing(-2, 0),
    },
  },
}));

export const NoItemsText = styled("p")({
  font: fonts.bodyLarge,
  color: colors.neutral80,
  alignSelf: "start",
});
